// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2UGxU","footer":"ModalUpdate_footer__1dcSj"};